import { observable, set } from 'mobx';
import { IFromCompanyBillingDetailsResponse } from '../../../api/IDataMappings';
import { FIELD_TYPE } from '../../../constants/Constants';

class CompanyBillingDetails {
  @observable
  public readonly attributes: IFromCompanyBillingDetailsResponse;

  constructor() {
    this.attributes = {
      [FIELD_TYPE.BILL_TO_COMPANY]: false,
      [FIELD_TYPE.COMPANY_ADDRESS]: '',
      [FIELD_TYPE.COMPANY_NAME]: '',
      [FIELD_TYPE.COMPANY_TAX_NUMBER]: '',
    };
  }

  public static fromJSON(data: IFromCompanyBillingDetailsResponse): CompanyBillingDetails {
    const companyBillingDetails = new CompanyBillingDetails();

    const { ...rest } = data;
    set(companyBillingDetails.attributes, {
      ...rest,
    });

    return companyBillingDetails;
  }

  public toJSON(): IFromCompanyBillingDetailsResponse {
    return {
      ...this.attributes,
    };
  }
}
export default CompanyBillingDetails;
